import { Stack } from '@mui/material';
import MotiveChart from 'features/augmented-writing/analysis-results/motive-chart';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';
import { ProfileValues } from 'types/profile.types';
import ContactPersonality from './contact-personality';
import MatchCompareGraph from './match-compare-graph';

interface Props {
  contactName: string | undefined;
  contactAssessment: Assessment | undefined;
  contactProfile: ProfileValues | undefined;
  userProfile: ProfileValues | undefined;
}

const StyleMatch: React.FC<Props> = ({ contactName, contactAssessment, contactProfile, userProfile }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack gap={1} sx={{ height: '100%' }}>
      {!_.isNil(contactProfile) ? (
        <Stack direction={'row'} alignItems={'flex-start'} gap={1}>
          <div className={classes.card}>
            <MotiveChart contactScores={contactProfile} userScores={userProfile} />
          </div>
          {!_.isNil(contactProfile?.authenticity) ? (
            <MatchCompareGraph
              title={t('languageStyle')}
              leftText={t('formal')}
              rightText={t('informal')}
              contactScore={contactProfile?.authenticity}
              userScore={userProfile?.authenticity}
            />
          ) : null}
        </Stack>
      ) : null}
      {!_.isNil(contactAssessment) ? <ContactPersonality contactName={contactName} assessment={contactAssessment} /> : null}
    </Stack>
  );
};

const useStyles = makeStyles()(() => ({
  card: {
    width: '100%',
    height: '100%',
    background: '#FFF',
    padding: '16px',
    borderRadius: '8px',
  },
}));

export default StyleMatch;
